export const scrollToSection = (selector) => {
  const target = document.querySelector(selector);
  if (!target) return;
  const offset = selector === "#architecture" ? -90 : -20;
  if (window.lenis) {
    window.lenis.scrollTo(target, { offset });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};
